<template>
	<JBox class="s-bg-white s-border-gray-300 s-border s-px-4 s-pb-4 s-rounded-lg">
		<!-- Input Fields -->
		<JHeadline class="s-text-gray-900 s-text-md s-font-medium s-mt-4">{{ $t("templates.inputFields") }}</JHeadline>
		<JBox v-if="!inputs">
			{{ $t("templates.noFunctionTemplateData") }}
		</JBox>
		<JBox v-else>
			<div v-for="(item, index) in inputs" :key="index" class="s-mt-4">
				<p class="s-mb-1">{{ item.var }}</p>
				<JFlex class="s-justify-between s-items-center">
					<div
						@click="handleInputSelect(index)"
						class="s-cursor-pointer s-w-full s-p-2 s-border s-rounded s-border-gray-300"
						:class="item.isNotExist ? 's-border-red-500' : item.isNotAdded ? 's-border-yellow-300' : 's-border-gray-300'"
					>
						<span>{{ item.liquid || "---" }}</span>
					</div>

					<div v-if="item.isNotExist" class="s-ml-2 s-cursor-pointer" @click="removeTemplateInput(item.id)">
						x
					</div>
				</JFlex>
				<div v-if="item.isNotAdded" class="s-text-sm s-font-medium s-mt-1 s-text-yellow-300">
					{{ $t("templates.inputNotAdded") }}
				</div>
				<div v-if="item.isNotExist" class="s-text-sm s-font-medium s-mt-1 s-text-red-500">
					{{ $t("templates.inputNotExist") }}
				</div>
			</div>
		</JBox>

		<!-- LiquidPicker -->
		<CModal variant="default" zIndex="10000" :isVisible="showLiquidPicker" @overlay:click="toggleLiquidPicker">
			<JBox class="s-p-4">
				<CLiquidPicker @data:selected="handleLiquidPicker" />
			</JBox>
		</CModal>
	</JBox>
</template>

<script>
import api from "@/api/api"
import { mutation } from "../../api/queries"
/**
 * WHAT HAPPENS HERE ?
 *
 *  1 We compare Excel Inputs and Template Inputs to determine which inputs are already added on template
 *  - Inputs existing on Excel but not added on Template will be highlighted with a yellow border
 *  - Inputs existing on both Excel and Template will have a normal border
 *  - Inputs NOT existing on Excel but added on Template will be highlighted with a red border (This happens when we switch and parse a different excel file, the parsed i)
 */

export default {
	props: {
		id: {
			type: String
		},
		templateInputs: {
			type: Array
		},
		excelInputs: {
			type: Array
		},
		inputPrefix: {
			type: String
		}
	},

	data() {
		return {
			inputs: [],
			selectedIndex: null,

			showLiquidPicker: false
		}
	},

	methods: {
		compareInputs(excelInputs, templateInputs) {
			const array1 = excelInputs?.map(item => item.label)
			const array2 = templateInputs?.map(item => item.var)
			const itemsNotAdded = array1?.filter(item => !array2?.includes(item))
			const itemsNotExist = array2?.filter(item => !array1?.includes(item))
			return { itemsNotAdded, itemsNotExist }
		},
		decideInputs({ itemsNotExist, itemsNotAdded }) {
			let output = []
			// Inputs NOT existing on Excel but added on Template will be highlighted with a red border
			output = this.inputs?.map(item => {
				if (itemsNotExist?.includes(item.var)) {
					return { ...item, isNotExist: true }
				} else return item
			})
			if (this?.inputs?.length > 0) {
				// Inputs existing on Excel but not added on Template will be highlighted with a yellow border
				output.push(
					...itemsNotAdded?.map(item => ({
						var: item,
						liquid: null,
						isNotAdded: true
					}))
				)
			} else {
				output = [
					...itemsNotAdded?.map(item => ({
						var: item,
						liquid: null,
						isNotAdded: true
					}))
				]
			}
			return output
		},
		toggleLiquidPicker() {
			this.showLiquidPicker = !this.showLiquidPicker
		},
		handleInputSelect(index) {
			this.selectedIndex = index
			this.toggleLiquidPicker()
		},
		handleLiquidPicker(payload) {
			this.toggleLiquidPicker()
			const foundInput = this.inputs[this.selectedIndex]
			foundInput.liquid = payload
			if (foundInput?.isNotExist) return
			if (foundInput?.isNotAdded) {
				this.addTemplateInput(foundInput)
			} else this.updateTemplateInput(foundInput)
		},
		async addTemplateInput(payload) {
			const input = {
				name: payload?.var?.replace(this.inputPrefix, ""),
				var: payload?.var,
				liquid: payload?.liquid
			}
			const variables = {
				id: this.id,
				input
			}
			const res = await api({ query: mutation.addInputToFunctionTemplate, variables })
			if (res?.data?.addInputToFunctionTemplate?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.addInputToFunctionTemplate?.errors?.[0] }
				})
			} else {
				// manually changing local state so that we dont have to refetch template
				this.inputs[this.selectedIndex] = {
					id: res?.data?.addInputToFunctionTemplate?.createdStatus?.id,
					...input
				}
			}

			const { itemsNotAdded, itemsNotExist } = this.compareInputs(this.excelInputs, this.inputs)
			this.inputs = this.decideInputs({ itemsNotAdded, itemsNotExist })
		},
		async updateTemplateInput(payload) {
			const input = {
				name: payload?.var?.replace(this.inputPrefix, ""),
				var: payload?.var,
				liquid: payload?.liquid
			}
			const variables = {
				templateId: this.id,
				inputId: payload.id,
				input
			}
			const res = await api({ query: mutation.updateInputOfFunctionTemplate, variables })
			if (res?.data?.updateInputOfFunctionTemplate?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.updateInputOfFunctionTemplate?.errors?.[0] }
				})
			} else {
				// manually changing local state so that we dont have to refetch template
				this.inputs[this.selectedIndex] = {
					id: payload?.id,
					...input
				}
			}
			const { itemsNotAdded, itemsNotExist } = this.compareInputs(this.Excelnputs, this.inputs)
			console.log(this.decideInputs({ itemsNotAdded, itemsNotExist }))
			this.inputs = this.decideInputs({ itemsNotAdded, itemsNotExist })
		},
		async removeTemplateInput(id) {
			const variables = {
				templateId: this.id,
				inputId: id
			}
			const res = await api({ query: mutation.removeInputFromFunctionTemplate, variables })
			if (res?.data?.removeInputFromFunctionTemplate?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.removeInputFromFunctionTemplate?.errors?.[0] }
				})
			} else {
				this.inputs = this.inputs?.filter(item => item.id !== id)
			}
		}
	},

	watch: {
		templateInputs: {
			handler() {
				this.inputs = this.templateInputs
			},
			immediate: true,
			deep: true
		},
		excelInputs: {
			handler() {
				const { itemsNotAdded, itemsNotExist } = this.compareInputs(this.excelInputs, this.templateInputs)
				this.inputs = this.decideInputs({ itemsNotAdded, itemsNotExist })
			},
			immediate: true
		}
	}
}
</script>
